angular.module('TetherApp').directive('fieldInput', function () {
	console.log('wuh?');
    return {
        restrict: 'E',
        scope: false,
        template:
            '<section layout-padding ng-if="control != null">' +
            '<h4 style="padding-left: 24px;">{{ control.type | snakeToPascal }}</h4>' +
            '<md-list>' +
            '<md-list-item flex layout="row">' +
            '<md-button ng-click="configureController.parent.removeControl(idx);" class="md-raised md-accent md-button md-default-theme">Delete</md-button>' +
            '</md-list-item>' +
            '<md-list-item ng-repeat="(prop, value) in configureController.parent.survey.form.fields[configureController.parent.currentFieldIndex].controls[idx]" flex layout="row" ng-if="prop != \'type\' && prop != \'json_id\'">' +
            '<md-input-container flex="100" ng-if="prop != \'options\'">' +
            '<label>{{ prop | snakeToPascal }}</label>' +
            '<input type="text" ng-model="configureController.parent.survey.form.fields[configureController.parent.currentFieldIndex].controls[idx][prop]"/>' +
            '</md-input-container>' +
            '<md-list style="display:block; width:100%;" ng-if="prop == \'options\'">' +
            '<h5 style="width: 100%;">Options</h5>' +
            '<md-button ng-click="configureController.parent.addOption(idx);" class="md-raised md-accent md-button md-default-theme">Add Option</md-button>' +
            '<md-list-item ng-repeat="(optionkey, optionvalue) in configureController.parent.survey.form.fields[configureController.parent.currentFieldIndex].controls[idx][prop] track by $index" flex layout="column" layout-align="start center" ng-if="prop != \'type\' && prop != \'json_id\' && optionvalue != undefined">' +
            '<h5 style="width:100%; font-weight: bold;">Option {{ optionvalue[\'json_id\'] }}</h5>' +
            '<md-input-container flex layout="row" style="width: 100%;">' +
            '<md-button ng-click="configureController.parent.removeOption(idx, optionkey);" class="md-raised md-accent md-button md-default-theme">Delete</md-button>' +
            '</md-input-container>' +
            '<md-input-container style="display:block; width:100%;" flex="100" ng-repeat="(innerprop, innervalue) in configureController.parent.survey.form.fields[configureController.parent.currentFieldIndex].controls[idx][prop][optionkey]" ng-if="innerprop != \'json_id\'">' +
            '<label>{{ innerprop | snakeToPascal }}</label>' +
            '<input type="text" ng-model="configureController.parent.survey.form.fields[configureController.parent.currentFieldIndex].controls[idx][prop][optionkey][innerprop]"/>' +
            '</md-input-container>' +
            '</md-list-item>' +
            '<md-list>' +
            '</md-list-item>' +
            '</md-list>' +
            '</section>'
    }
});
